module.exports = __webpack_public_path__ + "img/the-paradox-of-false-belief-understaning--epistemic-studies-cover.937e6e3b.jpg";